<body>
  <section>
    <div class="body-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3">
            <div class="logo">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-03)/assets/image/logo.png"
                alt="logo"
              />
            </div>
          </div>
          <div class="col-lg-2"></div>
          <div class="col-lg-7 text-right">
            <div class="social-img">
              <a
                href="https://onpassive.com/blog"
                target="_blank"
                rel="noopener"
                title="ONPASSIVE Blog"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/blog1.png"
                  class="blogicon"
                  alt="blog1"
                />
              </a>
              <a
                href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Facebook"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/fb.png"
                  alt="facebook"
                />
              </a>
              <a
                href="https://twitter.com/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Twitter"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/twitter.png"
                  alt="twitter"
                />
              </a>
              <a
                href="https://www.instagram.com/ONPASSIVE/"
                target="_blank"
                rel="noopener"
                title="Instagram"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/insta.png"
                  alt="Instagram"
                />
              </a>
              <a
                href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Youtube"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/youtube.png"
                  alt="YouTube"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                target="_blank"
                rel="noopener"
                title="LinkedIn"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-03)/assets/image/icon/in.png"
                  alt="LinkedIn"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <!--     <div class="col-lg-1"></div> -->
          <div class="col-lg-6 mt-5">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="mob mt-5">
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(feb-03)/assets/image/launch.png"
                    class="launch"
                    alt="launch"
                  />
                  <h4 class="internet text-white mt-3">
                    Versatile Online Business Solution
                  </h4>
                  <!--  <h1 class=" ml12">LAUNCHING SOON</h1> -->
                  <p class="content2 text-white">
                    It doesn't matter if your business is not online, and it
                    definitely doesn't matter if you're not tech-savvy. We cover
                    your business needs and transform your business to make it
                    malleable, flexible, and complete online marvel. The
                    transformation is made possible by the constant effort of
                    our team, who come up with innovative and creative ideas
                    dedicated to solving online business issues. These ideas
                    reflect on the tools designed for exceeding productivity and
                    data transparency.
                  </p>
                  <a
                    href="/registration/user?reg={{ userId }}"
                    name="regform"
                    target="_blank"
                    rel="noopener"
                    class="become_button"
                    >Become a Founder Now</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4"></div>
          <div class="col-lg-2"></div>
        </div>
      </div>
    </div>
  </section>
  <section class="second-section" data-aos-easing="linear">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-1">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive(feb-03)/assets/image/Datatransperancy.png"
            alt="datatransperancy"
          />
        </div>
        <div class="col-lg-3">
          <div class="point1">
            <h3 class="second-section-head">Data Transparency</h3>
            <p class="second-section-para">
              Get high visibility to the data linked with each business activity
              through the customizable metrics dashboard.
            </p>
          </div>
        </div>
        <div class="col-lg-1">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive(feb-03)/assets/image/EasyPlanningandForecasting.png"
            alt="ep&c"
          />
        </div>
        <div class="col-lg-3">
          <div class="point1">
            <h3 class="second-section-head">Easy Planning and Forecasting</h3>
            <p class="second-section-para">
              Information collected from various data points helps the AI-driven
              tools to make critical decisions through data forecasting
              techniques and pattern recognition.
            </p>
          </div>
        </div>
        <div class="col-lg-1">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive(feb-03)/assets/image/NoNeedtoRecruit.png"
            alt="NNR"
          />
        </div>
        <div class="col-lg-3">
          <div class="point1">
            <h3 class="second-section-head">No Need to Recruit</h3>
            <p class="second-section-para">
              Hiring to get work done is past. At ONPASSIVE, you receive a
              self-motivated team dedicated to working for your vision and
              goals.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="third-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <h2 class="become" data-aos-easing="ease-in-sine">
            Become Online <br /><span class="sensation"
              >Sensation Overnight</span
            >
          </h2>
          <p
            class="para1"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
          >
            ONPASSIVE provides a centralized online solution to automate
            business functions and ensures you leverage the benefits of various
            tools designed especially for your requirements. Each tool shared
            with you is fully-customizable and highly data-oriented. Now keep
            track of how different departments are functioning and which
            critical decisions are showing better results.
          </p>
        </div>
        <div class="col-lg-6">
          <div class="video-box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fourth-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h1 class="become">
            Main Features of tools offered by
            <span class="sensation">ONPASSIVE</span>
          </h1>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-6 text-center" data-aos-easing="ease-out-cubic">
          <div class="fourth-section1">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="business-time"
              class="svg-inline--fa fa-business-time fa-w-20"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
              width="100"
              height="100"
              style="color: #1d4555"
            >
              <path
                fill="currentColor"
                d="M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
              ></path>
            </svg>
            <h1 class="fourth1">Business Automation</h1>
            <p class="fourth2">
              End-to-end automation of business activities delivers maximum
              output and streamlined operations.
            </p>
          </div>
        </div>
        <div class="col-lg-6 text-center" data-aos-easing="ease-out-cubic">
          <div class="fourth-section1">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="wifi"
              class="svg-inline--fa fa-wifi fa-w-20"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
              width="100"
              height="100"
              style="color: #1d4555"
            >
              <path
                fill="currentColor"
                d="M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
              ></path>
            </svg>
            <h1 class="fourth1">Guaranteed Web Traffic</h1>
            <p class="fourth2">
              Automated promotion of products and services ensure free web
              traffic to your business sites.
            </p>
          </div>
        </div>
        <div class="col-lg-6 text-center" data-aos-easing="ease-out-cubic">
          <div class="fourth-section1">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="plug"
              class="svg-inline--fa fa-plug fa-w-12"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
              width="100"
              height="100"
              style="color: #1d4555"
            >
              <path
                fill="currentColor"
                d="M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
              ></path>
            </svg>
            <h1 class="fourth1">Plug-n-Play Tools</h1>
            <p class="fourth2">
              Easy to install tools require no technical knowledge and guide you
              through the entire installation step-by-step.
            </p>
          </div>
        </div>
        <div
          class="col-lg-6 text-center"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
        >
          <div class="fourth-section1">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="sync"
              class="svg-inline--fa fa-sync fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="100"
              height="100"
              style="color: #1d4555"
            >
              <path
                fill="currentColor"
                d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
              ></path>
            </svg>
            <h1 class="fourth1">End-to-End Coverage</h1>
            <p class="fourth2">
              Receive advanced AI-driven tools for various business activities,
              such as web designing, hosting, ads, and promotions, etc.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fifth-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center mt-5">
          <h1 class="text-white ml12">BECOME A FOUNDER NOW</h1>
          <p class="fifth-para text-white">
            With ONPASSIVE, you receive a chance to become a leader of your
            business industry. Take your business to the next level and become
            an inspiration for others who want to learn the new technique of
            doing business.
          </p>
          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
            class="become_button"
            >Become a Founder Now</a
          >
        </div>
      </div>
    </div>
  </section>
  <section class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center mt-3">
          <p class="text-white footer-content">
            &copy; 2022 ONPASSIVE - All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  </section>
  <!---------------------------Section End--------------------------------------------------------->
</body>
